// removed by extract-text-webpack-plugin
module.exports = {"trendItem":"antd-pro-trend-trendItem","up":"antd-pro-trend-up","down":"antd-pro-trend-down","trendItemGrey":"antd-pro-trend-trendItemGrey","reverseColor":"antd-pro-trend-reverseColor"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Trend/index.less
// module id = 655
// module chunks = 0